































import { defineComponent, ref, onMounted } from '@vue/composition-api';
import { getPresentationConfig } from '@/shared/verify-credit-controller';
import { VerifyStageEnum } from '@/shared/verify-credit-controller/types';
import { Popup } from '@hb/coffee';
import { ubtExposeNewOcr } from '@/shared/tools/ocr/tianqi';

/** 活动规则按钮&弹窗，用于身份认证页新老流程 */
export default defineComponent({
  name: 'ActivityRule',
  props: {
    className: {
      type: String,
      default: '',
    },
  },
  components: {
    Popup,
  },
  setup() {
    const showRulePopup = ref(false);
    const ruleText = ref(getPresentationConfig()[VerifyStageEnum.ID_CARD]?.ruleText);

    onMounted(() => {
      if (ruleText.value) {
        ubtExposeNewOcr('finance_loan_ocr_identify_activity_rule');
      }
    });

    /** 打开活动规则弹窗 */
    const openRulePopup = () => {
      showRulePopup.value = true;
      ubtExposeNewOcr('finance_loan_ocr_identify_activity_rule_popUp');
    };

    return {
      showRulePopup,
      ruleText,
      openRulePopup,
    };
  },
});
